import { InstantSearch } from 'react-instantsearch';
import { PortalProvider, Portal } from '@rmwc/base';
import { indexName, instanceSearchClient } from './SearchClient';
import { Provider } from 'react-redux';
import store from '../../store';
import { useState } from 'react';
import HubSearch from './HubSearch';

const HubSearchWrapper = (props) => {
  const { dateFilterField } = props;

  // if we can filter by date, we want to show the newest first
  const indexToUse = dateFilterField ? `${indexName}_newest` : indexName;

  const [selectedIndexForSort, setSelectedIndexForSort] =
    useState<string>(indexToUse);

  return (
    <Provider store={store}>
      <PortalProvider>
        <InstantSearch
          searchClient={instanceSearchClient}
          indexName={selectedIndexForSort}
        >
          <HubSearch {...props} setIndexForSort={setSelectedIndexForSort} />
        </InstantSearch>
        <Portal />
      </PortalProvider>

      <div className="case-notes__overlay"></div>
    </Provider>
  );
};

export default HubSearchWrapper;
